import {
  TextInput,
  ImageInput,
  ReferenceArrayInput,
  AutocompleteArrayInput,
  SimpleForm,
  ArrayInput,
  SimpleFormIterator,
} from 'react-admin'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'

import CustomImageField from '../../components/CustomImageField'
import BookToolbar from '../../components/BookToolbar'
import GridContainer from '../../components/GridContainer'
import { validateRequired } from '../../utils/validate'

import KidSeriesStoriesInput from './KidSeriesStoriesInput'

const KidSeriesForm = props => {
  return (
    <SimpleForm
      toolbar={<BookToolbar />}
      redirect="list"
      variant="standard"
      margin="normal"
      {...props}>
      <GridContainer>
        <Grid item xs={12}>
          <TextInput
            source="title"
            fullWidth
            variant="standard"
            validate={validateRequired('Title')}
          />
        </Grid>
        <Grid item xs={12}>
          <TextInput
            source="description"
            resettable
            rows={4}
            fullWidth
            variant="standard"
            multiline
          />
        </Grid>
        <Grid item xs={12}>
          <ReferenceArrayInput
            label="Topics"
            source="topicIds"
            reference="topics"
            filter={{ type: ['kids_story', 'all'] }}>
            <AutocompleteArrayInput
              optionText="name"
              fullWidth
              variant="standard"
              filterToQuery={searchText => ({
                name: { $iLike: `%${searchText}%` },
              })}
            />
          </ReferenceArrayInput>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="subtitle2" color="textSecondary" gutterBottom>
            List Stories
          </Typography>
          <KidSeriesStoriesInput />
        </Grid>
        <Grid item xs={12}>
          <ArrayInput
            source="coverImages"
            fullWidth
            validate={[validateRequired('coverImages')]}>
            <SimpleFormIterator>
              <ImageInput
                source="url"
                label="Cover image"
                accept="image/*"
                multiple={false}>
                <CustomImageField source="src" title="Cover image" />
              </ImageInput>
            </SimpleFormIterator>
          </ArrayInput>
        </Grid>
        <Grid item xs={12}>
          <ImageInput
            source="bannerImageMobile"
            label="Banner Image Mobile"
            accept="image/*"
            multiple={false}>
            <CustomImageField source="src" title="Banner Image Mobile" />
          </ImageInput>
        </Grid>
        <Grid item xs={12}>
          <ImageInput
            source="bannerImageTablet"
            label="Banner Image Tablet"
            accept="image/*"
            multiple={false}>
            <CustomImageField source="src" title="Banner Image Tablet" />
          </ImageInput>
        </Grid>
      </GridContainer>
    </SimpleForm>
  )
}

export default KidSeriesForm
